import { FormRow } from './FormRow';
import { MainBtn, CancelBtn } from './Buttons';
import { Input } from './Inputs';
import { DropDownMenu } from './DropDownMenu';
import { CategoryDropDownMenu } from './CategoryDropDownMenu';
import {
    AddRoleSelect,
    AddCompanyAdminSelect,
    AddCompanyOwnerSelect,
    AddCompanyManagerSelect,
    AddPharmacyAdminSelect,
    AddPharmacyOwnerSelect,
    AddPharmacyManagerSelect
} from './Selects-add';

import {
    EditRoleSelect,
    EditCompanyAdminSelect,
    EditCompanyOwnerSelect,
    EditCompanyManagerSelect,
    EditPharmacyAdminSelect,
    EditPharmacyOwnerSelect,
    EditPharmacyManagerSelect
} from './Selects-edit';

import { CompanySelect, CompanyUserSelect, PharmacyUserSelect } from './Selects';
import { CompanySelectV2, PharmacySelectV2, OrderStatusSelectV2 } from './SelectsV2';
import { CustomSlider as Slider } from './Slider';
import { Switch } from './Switch';

export {
    FormRow,
    MainBtn,
    CancelBtn,
    EditRoleSelect,
    CompanySelect,
    CompanyUserSelect,
    PharmacyUserSelect,
    AddRoleSelect,
    AddCompanyAdminSelect,
    AddCompanyOwnerSelect,
    AddCompanyManagerSelect,
    EditCompanyAdminSelect,
    EditCompanyOwnerSelect,
    EditCompanyManagerSelect,
    AddPharmacyAdminSelect,
    AddPharmacyOwnerSelect,
    AddPharmacyManagerSelect,
    EditPharmacyAdminSelect,
    EditPharmacyOwnerSelect,
    EditPharmacyManagerSelect,
    Input,
    CompanySelectV2,
    PharmacySelectV2,
    OrderStatusSelectV2,
    DropDownMenu,
    CategoryDropDownMenu,
    Slider,
    Switch
};



// WEBPACK FOOTER //
// ./src/customModules/Common/form/Elements-export.js